import CancelablePromise, { cancelable } from "cancelable-promise";

interface FakePromise {
	then: (cb: () => void) => void;
}

export class PromisePool {
	private pool = new Map<number, CancelablePromise>();
	private poolId: number = 0;

	private getFreeId(): number {
		let id = 0; // NOTE: Mindig elsőnek a 0-át nézzük meg
		while (this.pool.has(id)) {
			id = Math.random();
		}

		return id;
	}

	public add<Type>(promise: Promise<Type> | CancelablePromise<Type>): CancelablePromise<Type> {
		const id = this.getFreeId();
		const cancelablePromise = "cancel" in promise ? promise : cancelable(promise);

		this.pool.set(id, cancelablePromise);

		return cancelablePromise.finally(() => {
			this.pool.delete(id);
		}, true);
	}

	public addTimeout(ms: number = 3_000): CancelablePromise<any> {
		const cancelablePromise = new CancelablePromise((resolve) => {
			setTimeout(resolve, ms);
		});

		return this.add(cancelablePromise);
	}

	public addInterval(ms: number): FakePromise {
		return {
			then: (cb: () => void) => {
				this.addTimeout(ms).then(() => {
					cb();

					this.addInterval(ms).then(cb);
				});
			},
		};
	}

	public cancel(): void {
		this.pool.forEach((cancelablePromise) => cancelablePromise.cancel());
		this.pool.clear();
	}
}
